/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { TasksApiConfiguration as __Configuration } from '../tasks-api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { ListQueryResultTaskCategoryInfo } from '../models/list-query-result-task-category-info';
import { CreateTaskCategoryCommand } from '../models/create-task-category-command';
import { UpdateTaskCategoryCommand } from '../models/update-task-category-command';
import {TaskCategoryInfo} from "../models/task-category-info";
@Injectable({
  providedIn: 'root',
})
class TaskCategoryService extends __BaseService {
  static readonly GetAllPath = '/api/tasks/categories';
  static readonly GetTaskCategoryPath = '/api/tasks/categories/{id}';
  static readonly CreateTaskCategoryPath = '/api/tasks/categories';
  static readonly GetUpdateTaskCategoryPath = '/api/tasks/categories/{id}/update';
  static readonly UpdateTaskCategoryPath = '/api/tasks/categories/{id}/update';
  static readonly DeleteTaskCategoryPath = '/api/tasks/categories/{id}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param params The `TaskCategoryService.GetAllParams` containing the following parameters:
   *
   * - `sortFields`:
   *
   * - `sortCriteria`:
   *
   * - `pattern`:
   *
   * - `pageSize`:
   *
   * - `pageNumber`:
   *
   * - `companyId`:
   *
   * @return Success
   */
  GetAllResponse(params: TaskCategoryService.GetAllParams): __Observable<__StrictHttpResponse<ListQueryResultTaskCategoryInfo>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    (params.sortFields || []).forEach(val => {if (val != null) __params = __params.append('sortFields', val.toString())});
    (params.sortCriteria || []).forEach(val => {if (val != null) __params = __params.append('sortCriteria', val.toString())});
    if (params.pattern != null) __params = __params.set('pattern', params.pattern.toString());
    if (params.pageSize != null) __params = __params.set('pageSize', params.pageSize.toString());
    if (params.pageNumber != null) __params = __params.set('pageNumber', params.pageNumber.toString());
    if (params.companyId != null) __params = __params.set('companyId', params.companyId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/tasks/categories`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ListQueryResultTaskCategoryInfo>;
      })
    );
  }

  GetTaskCategoryResponse(id: string): __Observable<__StrictHttpResponse<TaskCategoryInfo>> {
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/tasks/categories/${id}`,
      __body,
      {
        headers: __headers,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<TaskCategoryInfo>;
      })
    );
  }
  /**
   * @param params The `TaskCategoryService.GetAllParams` containing the following parameters:
   *
   * - `sortFields`:
   *
   * - `sortCriteria`:
   *
   * - `pattern`:
   *
   * - `pageSize`:
   *
   * - `pageNumber`:
   *
   * - `companyId`:
   *
   * @return Success
   */
  GetAll(params: TaskCategoryService.GetAllParams): __Observable<ListQueryResultTaskCategoryInfo> {
    return this.GetAllResponse(params).pipe(
      __map(_r => _r.body as ListQueryResultTaskCategoryInfo)
    );
  }

  GetTaskCategory(id: string): __Observable<TaskCategoryInfo> {
    return this.GetTaskCategoryResponse(id).pipe(
      __map(_r => _r.body as TaskCategoryInfo)
    );
  }

  /**
   * @param command undefined
   */
  CreateTaskCategoryResponse(command?: CreateTaskCategoryCommand): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = command;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/tasks/categories`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param command undefined
   */
  CreateTaskCategory(command?: CreateTaskCategoryCommand): __Observable<null> {
    return this.CreateTaskCategoryResponse(command).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * @param id undefined
   * @return Success
   */
  GetUpdateTaskCategoryResponse(id: string): __Observable<__StrictHttpResponse<UpdateTaskCategoryCommand>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/tasks/categories/${id}/update`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UpdateTaskCategoryCommand>;
      })
    );
  }
  /**
   * @param id undefined
   * @return Success
   */
  GetUpdateTaskCategory(id: string): __Observable<UpdateTaskCategoryCommand> {
    return this.GetUpdateTaskCategoryResponse(id).pipe(
      __map(_r => _r.body as UpdateTaskCategoryCommand)
    );
  }

  /**
   * @param params The `TaskCategoryService.UpdateTaskCategoryParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `command`:
   */
  UpdateTaskCategoryResponse(params: TaskCategoryService.UpdateTaskCategoryParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.command;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/api/tasks/categories/${params.id}/update`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param params The `TaskCategoryService.UpdateTaskCategoryParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `command`:
   */
  UpdateTaskCategory(params: TaskCategoryService.UpdateTaskCategoryParams): __Observable<null> {
    return this.UpdateTaskCategoryResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * @param id undefined
   */
  DeleteTaskCategoryResponse(id: string): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/api/tasks/categories/${id}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param id undefined
   */
  DeleteTaskCategory(id: string): __Observable<null> {
    return this.DeleteTaskCategoryResponse(id).pipe(
      __map(_r => _r.body as null)
    );
  }
}

module TaskCategoryService {

  /**
   * Parameters for GetAll
   */
  export interface GetAllParams {
    sortFields?: Array<any>;
    sortCriteria?: Array<any>;
    pattern?: string;
    pageSize?: number;
    pageNumber?: number;
    companyId?: string;
  }

  /**
   * Parameters for UpdateTaskCategory
   */
  export interface UpdateTaskCategoryParams {
    id: string;
    command?: UpdateTaskCategoryCommand;
  }
}

export { TaskCategoryService }
